import React, { useEffect, useState } from "react";
import AddMasterInventory from "./AddMasterParts";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import "./styles.scss";

import EditMasterParts from "./EditMasterParts";
import AddMasterParts from "./AddMasterParts";
import LoadingSpinner from "../../../components/LoadingSpinner";
import EmptyRows from "../../../components/reusableComponent/EmptyRows";
import DeleteModal from "../DeleteModal";
import {
    useDeleteAllMasterInventoryMutation,
    useGetAllMasterInventoryQuery,
} from "../../../Services/inventory/Inventory";
import useThemeColors from "../../vehicle/ThemeColors";
import ReactModal from "react-modal";
import { capitalizeFirstLetter } from "../../../components/reusableComponent/CapitalLetter";

const MasterParts = () => {
    const [inventoryData, setInventoryData] = useState([]);
    const [tableLoader, setTableLoader] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const [storeData, setStoreData] = useState({});

    const {
        data: masterInventoryData,
        status,
        isLoading,
        refetch,
    } = useGetAllMasterInventoryQuery({});
    const [triggerDelete] = useDeleteAllMasterInventoryMutation();

    useEffect(() => {
        if (masterInventoryData) {
            setInventoryData(masterInventoryData?.results);
        }
    }, [masterInventoryData]);

    useEffect(() => {
        if (status === "pending") {
            setTableLoader(true);
        } else {
            setTableLoader(false);
        }
    }, [status]);

    const masterTableHeader = [
        { label: "S.No", key: "sno" },
        { label: "HSN code", key: "hsn" },
        { label: "Part number", key: "part_id" },
        { label: "Part name", key: "inventory" },
        { label: "Price per unit", key: "price" },
        { label: "GST", key: "gst" },
    ];

    const addinventoryHandler = () => {
        setOpenModal(true);
    };

    const editModalHandler = (inventory: any) => {
        setStoreData(inventory);
        setOpenEditModal(true);
    };

    const isDeleteModal = (inventory) => {
        setStoreData(inventory);
        setOpenDeleteModal(true);
    };

    const closeModal = () => {
        setOpenModal(false);
        setOpenEditModal(false);
        setOpenDeleteModal(false);
        setModalOpen(false);
    };
    const {
        selectedColor,
        selectedBackgroundColor,
        selectedBorderColor,
        selectedButtonBackgoundColors,
        selectedButtonColors,
    } = useThemeColors();

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "40%",
        overflow: "scroll",
        bgcolor: "background.paper",
        border: "1px solid transparent",
        boxShadow: `${selectedColor}80 1px 1px 10px 1px`, // custom shadow
        borderRadius: "20px",
        p: 4,
        paddingBottom: "0",
    };

    const customModalStyles1: ReactModal.Styles = {
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-40%, -50%)",
            width: "70%",
            border: "none",
            borderRadius: "20px",
            boxShadow: `${selectedColor}80 1px 1px 10px 1px`,
        },
    };

    return (
        <div className="vehicle-info-cont">
            {/* <AddMasterParts closeModal={closeModal} refetch={refetch} /> */}

            <div className="workshops-header">
                <p
                    style={{
                        margin: "0",
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <span style={{ fontWeight: "600", fontSize: "20px" }}>
                        Master Parts  
                    </span>
                    <span
                        onClick={() => setModalOpen(true)}
                        style={{
                            color: `${selectedButtonColors}`,
                            background: `${selectedButtonBackgoundColors}`,
                            border: "none",
                            padding: "10px 25px",
                            borderRadius: "20px",
                            cursor: "pointer",
                        }}
                    >
                        + Part
                    </span>
                </p>
            </div>

            <div
                className="vehicle-info-bottom"
                style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px` }}
            >
                <div className="vehicle-info-bottom-heading">Parts</div>
                <table className="vehicle-info-bottom-table">
                    <thead
                        className="thead"
                        style={{
                            // display: "flex",
                            // justifyContent: "space-between",
                            // padding: "5px 15px",
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr",
                            gap: "20px"
                        }}
                    >
                        {masterTableHeader?.map((card, index) => (
                            <tr className="tr" style={{ padding: "5px 20px", display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr" }}>
                                <td style={{whiteSpace: "nowrap"}}>{card?.label === "GST" ? `${card.label} %` : card.label}</td>
                            </tr>
                        ))}
                        <td
                            style={{
                                width: "9%",
                                display: "flex",
                                justifyContent: " center",
                                alignItems: "center",
                                fontSize: "16px",
                                fontWeight: "500",
                            }}
                        >
                            Action
                            {/* <label
                                htmlFor=""
                                // style={{ paddingRight: "25px" }}
                            >
                                <strong>Action</strong>
                            </label> */}
                        </td>
                    </thead>
                    <tbody className="table-body">
                        {inventoryData?.map((vehicle, index) => (
                            <tr
                                className="table-body-tr"

                                style={{
                                    background:
                                        index % 2 !== 0 ? "#FFF1EC" : "white",
                                        display: "grid", 
                                        gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr",
                                        gap:"20px",

                                }}
                            >
                                <td style={{paddingLeft: "10px"}}>{index + 1}</td>
                                <td style={{paddingLeft: " 15px"}}>{vehicle?.hsnCode}</td>
                                <td style={{paddingLeft: "30px"}}>{vehicle?.partId}</td>
                                <td style={{paddingLeft: " 30px"}}>
                                    {capitalizeFirstLetter(
                                        vehicle?.inventoryName
                                    )}
                                </td>
                                <td style={{paddingLeft: " 30px"}}>{vehicle?.price_per_unit}</td>
                                <td style={{paddingLeft: " 30px"}}>{vehicle?.gst}</td>

                                <td
                                    style={{
                                        // display: "flex",
                                        // justifyContent: "center",
                                        alignItems: "center",
                                        gap: "10px",
                                        paddingLeft: "10px"
                                    }}
                                >
                                    <span
                                        onClick={() =>
                                            editModalHandler(vehicle)
                                        }
                                    >
                                        <i
                                            className="bi bi-pencil"
                                            style={{
                                                fontSize: "20px",
                                                cursor: "pointer",
                                            }}
                                        ></i>
                                    </span>
                                    {/* <span
                                    // onClick={() => deleteHandler(vehicle)}
                                    >
                                        <i
                                            className="bi bi-trash3"
                                            style={{
                                                fontSize: "20px",
                                                cursor: "pointer",
                                            }}
                                        ></i>
                                    </span> */}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* <Modal
                open={openDeleteModal}
                onClose={closeModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={{ ...style, position: "absolute" }}>
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: "fixed",
                            top: 16,
                            right: 16,
                            zIndex: 1301,
                            background: "white",
                        }} // Ensure it's above the modal content
                    >
                        <GridCloseIcon />
                    </IconButton>
                    <Typography
                        id="modal-title"
                        variant="h6"
                        component="h2"
                        sx={{ mb: 2 }}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        Delete Part
                    </Typography>

                    <Box>
                        <AddMasterParts
                            closeModal={closeModal}
                            refetch={refetch}
                   
                        />
                    </Box>
                </Box>
            </Modal> */}

            <Modal
                open={openEditModal}
                onClose={closeModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={{ ...style, position: "absolute" }}>
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: "fixed",
                            top: 16,
                            right: 16,
                            zIndex: 1301,
                            background: "white",
                        }} // Ensure it's above the modal content
                    >
                        <GridCloseIcon />
                    </IconButton>
                    <Typography
                        id="modal-title"
                        variant="h6"
                        component="h2"
                        sx={{ mb: 2 }}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            fontSize: "16px",
                            fontWeight: "600",
                        }}
                    >
                        Edit Part
                    </Typography>

                    <Box>
                        <EditMasterParts
                            closeModal={closeModal}
                            refetch={refetch}
                            storeValue={storeData}
                            // triggerDelete={triggerDeleteLaborId}
                            // agentMappingQueueData={agentMappingQueueData}
                        />
                    </Box>
                </Box>
            </Modal>
            <ReactModal
                isOpen={modalOpen}
                onRequestClose={closeModal}
                style={customModalStyles1}
            >
                <AddMasterParts closeModal={closeModal} refetch={refetch} />
            </ReactModal>
        </div>
    );
};

export default MasterParts;
